import MeetingGate from '../pages/MeetingGate';
import type { ResolvedDependencies } from './dependencies';

export default function AppShell({ cateringService, meetingService }: ResolvedDependencies) {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-col gap-4 p-4 flex-1">
        <MeetingGate cateringService={cateringService} meetingService={meetingService} />
      </div>
    </div>
  );
}
